import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import FancyToggle from '../elements/FancyToggle'

const options = {
    postUrl: '/api/postPstnSettings',
    showHideIcon: true,
    success: 'Success! Your phone settings have been successfully updated.'
}
const state = {}

class PstnSettingsForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <div className='mb-5'>
                    <h2 className='text-center text-md-left'>Manage my free features</h2>
                    <FancyToggle
                        title="Enable <span class='bold'>call return</span>"
                        name='enableCallReturn'
                        value={this.props.values.enableCallReturn}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Enable <span class='bold'>3 way call</span> function"
                        name='enable3WayCalling'
                        value={this.props.values.enable3WayCalling}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Enable <span class='bold'>call waiting</span>"
                        name='enableCallWaiting'
                        value={this.props.values.enableCallWaiting}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Make my <span class='bold'>number unlisted</span>"
                        name='numberUnlisted'
                        value={this.props.values.numberUnlisted}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Enable <span class='bold'>calling number display sending</span>"
                        name='enableCallingNumberDisplaySending'
                        value={this.props.values.enableCallingNumberDisplaySending}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Enable <span class='bold'>call divert</span>"
                        name='enableCallDivert'
                        value={this.props.values.enableCallDivert}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                </div>

                <div className='mb-3'>
                    <h2 className='text-center text-md-left'>Manage my chargeable features</h2>
                    <FancyToggle
                        title="Enable <span class='bold'>voicemail for $3/mth</span>"
                        name='enableVoicemail'
                        value={this.props.values.enableVoicemail}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Enable <span class='bold'>caller ID for $3/mth</span>"
                        name='enableCallerId'
                        value={this.props.values.enableCallerId}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                    <FancyToggle
                        title="Enable <span class='bold'>select call accept for $3/mth</span>"
                        name='enableSelectCallAccept'
                        value={this.props.values.enableSelectCallAccept}
                        errors={this.props.errors}
                        handleChange={this.props.setDynamicValues}
                    />
                </div>

                {this.props.children}

                <div className='mt-2'>
                    <Button title='Update Settings' action={this.props.handleSubmit} />
                </div>
            </form>
        )
    }
}

export default FormHOC(PstnSettingsForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/PstnSettingsForm.js